import { filter, forEach, includes, intersection, isArray, isUndefined } from "lodash";
import APIClient, { makeCancellableAPIRequest, failSafe } from "./index";
import { CustomColumnScope } from "types/tenantConfig";


const GlobalSettingAPI = {
    getTenantConfig(configType){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tenant-config?configType=${configType}`
        )
    },
    getDefaultTenantConfig(configType){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tenant-config/defaultValues?configType=${configType}`
        )
    },
    updateTenantConfig(configType, data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    data,
                    configType: configType
                }
            }
        )
    },
    update(data = {}){
        return makeCancellableAPIRequest(
            "POST",
            "/api/global-setting",
            {
                data
            }
        )
    },
    get(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/global-setting"
        )
    },
    getCustomizedTool() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/global-setting/customized-tool"
        )
    },
    getAdditionalTool() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/global-setting/additional-tools"
        )
    },
    postCustomizedTool(data = {}, showDefaultMessage = true) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/global-setting/customized-tool",
            {
                data
            },
            showDefaultMessage
        )
    },
    putCustomizedTool(data = {}, showDefaultMessage = true) {
        return makeCancellableAPIRequest(
            "PUT",
            "/api/global-setting/customized-tool",
            {
                data
            },
            showDefaultMessage
        )
    },
    deleteCustomizedTool(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/global-setting/customized-tool/${id}`
        )
    },
    getFindingSLA() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/findingSla"
        )
    },
    createFindingSLA(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/user/findingSla",
            {
                data,
            }
        )
    },
    updateFindingSLA(id, data) {
        return makeCancellableAPIRequest(
            "PUT",
            `/user/findingSla/${id}`,
            {
                data,
            }
        )
    },
    getFindingSLASchedule() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/findingSla/report-schedule"
        )
    },
    createFindingSLASchedule(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/user/findingSla/report-schedule",
            {
                data,
            }
        )
    },
    updateFindingSLASchedule(data, id) {
        return makeCancellableAPIRequest(
            "PUT",
            `/user/findingSla/report-schedule/${id}`,
            {
                data,
            }
        )
    },
    createSLA(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/findingSla/tiers/",
            {
                data,
            }
        )
    },
    getSLADetails(id) {
        return makeCancellableAPIRequest(
            "GET",
            `/user/findingSla/tiers/${id}`
        )
    },
    getAllSLA() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/findingSla/tiers"
        )
    },
    getSLAList() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/findingSla/tiers/list"
        )
    },
    updateSLA(id, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/findingSla/tiers/${id}`,
            {
                data,
            }
        )
    },
    deleteSLA(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/findingSla/tiers/${id}`,
        )
    },
    getAllRunbookTemplates(){
        return makeCancellableAPIRequest(
            "GET",
            `/api/template`,
        )
    },
    createRunbookTemplate(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/template`,
            {
                data
            }
        )
    },
    updateRunbookTemplate(data, id){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/template/${id}`,
            {
                data
            }
        )
    },
    updateGodModeAccess(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/update/god-mode-access`,
            {
                data
            }
        )
    },
    getCustomizedCategory() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=CATEGORY"
        )
    },
    getDependantFindingsConfig() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=DEPENDANT_FINDINGS"
        )
    },
    updateDependantFindingsConfig(data){
        return makeCancellableAPIRequest(
            "POST",
            '/api/tenant-config', 
            {
                data: {
                    data,
                    configType: "DEPENDANT_FINDINGS"
                },
            }
        )
    },
    addCustomizedCategory(data){
        return failSafe(
            APIClient.post('/api/tenant-config', {
                data,
                configType: "CATEGORY"
            })
        )
    },
    updateCustomizedCategory(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/tenant-config",
            {
                data: {
                    configType: "CATEGORY",
                    data
                }
            }
        )
    },
    deleteCustomizedCategory(data){
        return makeCancellableAPIRequest(
            "DELETE",
            "/api/tenant-config",
            {
                data: {
                    configType: "CATEGORY",
                    data
                }
            }
        )
    },
    getAllAllowedIPs() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenantConfig/allowedIPs"
        )
    },
    getAllowedIP(id) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/tenantConfig/allowedIPs/${id}`
        )
    },
    createAllowedIP(data) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/tenantConfig/allowedIPs`,
            {
                data
            }
        )
    },
    createAllowedIPBulk(data) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/tenantConfig/allowedIPs/bulk`,
            {
                data
            }
        )
    },
    updateAllowedIP(data) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/tenantConfig/allowedIPs`,
            {
                data
            }
        )
    },
    deleteAllowedIP(id){
        return failSafe(
            APIClient.delete(`/api/tenantConfig/allowedIPs/${id}`)
        )
    },
    getCustomizedStatus(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=PRODUCT_STATUS"
        )
    },
    createCustomizedStatus(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "PRODUCT_STATUS",
                    data
                }
            }
        )
    },
    customizedFindingStatus(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "MITIGATED_STATUS",
                    data
                }
            }
        )
    },
    getCustomizedFindingStatus(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=MITIGATED_STATUS"
        )
    },
    updateDevOpsWidgetConfig(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "DEVOPS_WIDGET_CONFIG",
                    data
                }
            }
        )
    },
    getDevOpsWidgetConfig(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=DEVOPS_WIDGET_CONFIG"
        )
    },
    getDevOpsWidgetConfigDefaultValues(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config/defaultValues?configType=DEVOPS_WIDGET_CONFIG"
        )
    },
    getOktaConfiguration() {
        return makeCancellableAPIRequest(
            "GET",
            `/api/ssoConfiguration`
        )
    },
    postUploadUrl(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/ssoConfiguration/saml/metadata/upload`,
            {
                data
            }
        )
    },
    saveOktaConfiguration(data) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/ssoConfiguration`,
            {
                data
            }
        )
    },
    deleteOktaConfiguration(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/ssoConfiguration/` + id
        )
    },
    getApplySSOInstantlyBoolean() {
        return this.getTenantConfig("APPLY_SSO_INSTANTLY");
    },
    checkRevertBackupStatus() {
        return makeCancellableAPIRequest(
            "GET",
            `/api/ssoConfiguration/backup-status`
        )
    },
    revertSSOConfiguration() {
        return makeCancellableAPIRequest(
            "POST",
            `/api/ssoConfiguration/revert`
        )
    },
    getOktaGroups(params) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/oktaConfiguration/groups`,
            { params }
        )
    },
    getOktaTeams() {
        return makeCancellableAPIRequest(
            "GET",
            `/api/oktaConfiguration/get-teams`,
        )
    },
    saveRolesMapping(data) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/oktaConfiguration/team/mapping`,
            { data }
        )
    },
    deleteRolesMapping() {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/oktaConfiguration/team/mapping`
        )
    },
    updateCustomizedStatus(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/tenant-config",
            {
                data: {
                    configType: "PRODUCT_STATUS",
                    data
                }
            }
        )
    },
    deleteCustomizedStatus(data){
        return makeCancellableAPIRequest(
            "DELETE",
            "/api/tenant-config",
            {
                data: {
                    configType: "PRODUCT_STATUS",
                    data
                }
            }
        )
    },
    getCustomizedTitles(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=CUSTOM_TITLES"
        )
    },
    getBUCustomizedTitles(buId){
        return makeCancellableAPIRequest(
            "GET",
            `/api/business-unit-setting/${buId}`
        )
    },
    updateCustomizedTitles(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/tenant-config",
            {
                data: {
                    configType: "CUSTOM_TITLES",
                    data
                }
            }
        )
    },
    getCustomizedFooterMessage(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=MESSAGES"
        )
    },
    updateCustomizedFooterMessage(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/tenant-config",
            {
                data: {
                    configType: "MESSAGES",
                    data
                }
            }
        )
    },
    getCustomizeDefaultDashboards(){
        const { promise, cancel } = makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=OUT_OF_BOX_DASHBOARD_STATUS"
        )
        const promise2 = promise.then((data) => {
            if (!data) {
                data = {};
            }
            if (!data.enabledDashboards) {
                data.enabledDashboards = [];
            }
            data.defaultDashboard = data.defaultDashboard?.toString();
            data.primaryDashboard = data.primaryDashboard?.toString();
            data.secondaryDashboard = data.secondaryDashboard?.toString();
            return data;
        });
        return { promise: promise2, cancel };
    },
    customizeDefaultDashboards(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/tenant-config",
            {
                data: {
                    configType: "OUT_OF_BOX_DASHBOARD_STATUS",
                    data,
                }
            }
        )

    },
    getRiskScorePreview(data){
        return makeCancellableAPIRequest(
            "POST",
            '/compliance/calculate/risk',
            {
                data
            }
        )
    },
    getCustomizedTicketSetting(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=TICKET_CONFIG"
        )
    },
    customizedTicketSetting(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "TICKET_CONFIG",
                    data
                }
            }
        )
    },
    saveROISettings(data) {
        return makeCancellableAPIRequest(
            "POST",
            "api/business-unit-setting",
            {
                data: {
                    configType: "ROI_DATA",
                    config: {
                        ...data
                    }
                }
            }
        )
    },
    getROISettings() {
        return makeCancellableAPIRequest(
            "GET",
            "api/business-unit-setting?configType=ROI_DATA"
        )
    },
    getReportPreference() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/preference/summaryReports"
        )
    },
    updateReportPreference(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/user/preference/summaryReports",
            {
                data
            }
        )
    },
    getCustomizedSeverityPrioity(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=SEVERITY_UPDATE_CONFIG"
        )
    },
    customizedSeverityPrioity(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "SEVERITY_UPDATE_CONFIG",
                    data
                }
            }
        )
    },
    getMaxAccpetRiskCount() {
        const promiseObj =  makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=ACCEPTRISK_COUNT"
        )
        promiseObj.promise = promiseObj.promise.then((res) => {
            if (res?.config) {
                return JSON.parse(res.config);
            }
            return res;
        });
        return promiseObj;
    },
    getFindingReopenState(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=FINDING_REOPEN_SLA"
        )
    },
    setFindingReopenState(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "FINDING_REOPEN_SLA",
                    data
                }
            }
        )
    },
    getVulnerabilityDensity(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=VULNERABILITY_DENSITY"
        )
    },
    setVulnerabilityDensity(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "VULNERABILITY_DENSITY",
                    data
                }
            }
        )
    },
    getAssetScoreTags(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=ASSET_SCORE"
        )
    },
    getAssetWeightingScores(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=ASSET_SCORE_WEIGHTING"
        )
    },
    updateAssetScoreTags(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "ASSET_SCORE",
                    data
                }
            }
        )
    },
    updateAssetWeightingScores(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "ASSET_SCORE_WEIGHTING",
                    data
                }
            }
        )
    },
    resetAssetScoreTags(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "ASSET_SCORE",
                    resetConfigToDefault: true,
                    data
                }
            }
        )
    },

    resetRiskRatings(){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "RISK_SCORE_RATINGS_CONFIG",
                    resetConfigToDefault: true,
                }
            }
        )
    },
    recalculateScore(){
        return makeCancellableAPIRequest(
            "POST",
            "/api/asset/score/recalculate"
        )
    },
    recalculateFindingScore(){
        return makeCancellableAPIRequest(
            "POST",
            "/api/finding/score/recalculate"
        )
    },
    updateIsRiskCalculationEnabled(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "RISK_SCORE",
                    data
                }
            }
        )
    },
    getIsRiskCalculationEnabled(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=RISK_SCORE",
        )
    },
    getRiskScoreBasedReleaseValidation(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=RISK_SCORE_BASED_BUILD_VALIDATION",
        )
    },
    updateRiskScoreBasedReleaseValidation(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "RISK_SCORE_BASED_BUILD_VALIDATION",
                    data
                }
            }
        )
    },
    getCustomizedFindingsColumns({ scope } = {}){
        const { cancel, promise } = makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=FINDINGS_VIEW_INDIRECT_COLUMNS_CONFIG"
        );
        return {
            cancel,
            promise: promise.then(response => {
                forEach(response?.tags, t => {
                    if(isUndefined(t.scope)){
                        t.scope = [CustomColumnScope.FINDING, CustomColumnScope.ASSETS, CustomColumnScope.DISCOVERY];
                    }
                })
                if (scope && response?.tags) {
                  response.tags = filter(response.tags, (tag) => {
                    if (isArray(scope)) {
                        return intersection(tag.scope, scope).length > 0;
                    }
                    return includes(tag.scope, scope);
                  });
                }
                return response;
            })
        }
    },
    updateCustomizedFindingsColumns(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "FINDINGS_VIEW_INDIRECT_COLUMNS_CONFIG",
                    data
                }
            }
        )
    },
    getAccountDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=ACCOUNT_DETAILS"
        )
    },
    createAccountDetails(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    data,
                    configType: "ACCOUNT_DETAILS"
                }
            }
        )
    },
    getStatusSeverityPreference(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=STATUS_SEVERITY_UPDATE_PREFERENCE"
        )
    },
    updateStatusSeverityPreference(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    data,
                    configType: "STATUS_SEVERITY_UPDATE_PREFERENCE"
                }
            }
        )
    },
    updateAccountDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/tenant-config",
            {
                data: {
                    data,
                    configType: "ACCOUNT_DETAILS"
                }
            }
        )
    },
    getTierBasedTags(){
        return this.getTenantConfig("TIER_BASED_TAGS");
    },
    updateTierBasedTags(data){
        return this.updateTenantConfig("TIER_BASED_TAGS", data);
    },
    validateTierBasedTags(tierId){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/tiers/${tierId}/utilisation`,
        )
    },
    getTestConnectionURL(data) {
        return makeCancellableAPIRequest(
            "POST",
            `api/ssoConfiguration/login-redirect-url`,
            { data }
        )
    },
    getLoginSSO(){
        return this.getTenantConfig("LOGIN_OPTIONS");
    },
    updateLoginSSO(data){
        return this.updateTenantConfig("LOGIN_OPTIONS", data);
    },
    getTagsLibrary(){
        return this.getTenantConfig("TAG_LIBRARY");
    },
    updateTagsLibrary(data, inheritanceOverrideTags){
        const payload = {library: data};
        if (inheritanceOverrideTags !== undefined) {
            payload.inheritanceOverrideTags = inheritanceOverrideTags;
        }
        return this.updateTenantConfig("TAG_LIBRARY", payload);
    },



    getSecurityToolDetails(){
        return this.getTenantConfig("SECURITY_TOOL_DETAILS");
    },

    updateSecurityToolDetails(data){
        return this.updateTenantConfig("SECURITY_TOOL_DETAILS", data);
    },
    
    getAiSettingsDetails() {
        return this.getTenantConfig("SUBMIT_TO_ARMOR_CODE_FOR_AI_SETTING");
    },

    updateAiSettings(data){
        return this.updateTenantConfig("SUBMIT_TO_ARMOR_CODE_FOR_AI_SETTING", data);
    },

    getRemediationGuidance() {
        return this.getTenantConfig("AI_REMEDIATION_ACTION");
    },

    updateRemediationGuidance(data){
        return this.updateTenantConfig("AI_REMEDIATION_ACTION", data);
    },

    getEnableDisableAnyaAIAssitant() {
        return this.getTenantConfig("ENABLE_ANYA_AI_ASSISTANT");
    },

    updateEnableDisableAnyaAIAssitant(data){
        return this.updateTenantConfig("ENABLE_ANYA_AI_ASSISTANT", data);
    },

    getAIFindingSummary() {
        return this.getTenantConfig("ENABLE_AI_SUMMARY ");
    },

    updateAIFindingSummary(data){
        return this.updateTenantConfig("ENABLE_AI_SUMMARY ", data);
    },

    createSecurityToolDetails(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    data,
                    configType: "SECURITY_TOOL_DETAILS"
                }
            }
        )
    },
    getExceptionConfig(){
        return this.getTenantConfig("EXCEPTION");
    },
    updateExceptionConfig(data){
        return this.updateTenantConfig("EXCEPTION", data);
    },
    getAcceptRiskReason(){
        return this.getTenantConfig("ACCEPT_RISK_REASON");
    },
    getControlledReason(){
        return this.getTenantConfig("CONTROLLED_REASON");
    },
    updateAcceptRiskReason(data){
        return this.updateTenantConfig("ACCEPT_RISK_REASON", data)
    },
    updateControlledReason(data){
        return this.updateTenantConfig("CONTROLLED_REASON", data)
    },

    
    updateSecureCodeWarriorConfig(data){
        return this.updateTenantConfig("SECURE_CODE_WARRIOR_TRAINING_CONFIG", data);
    },

    updateCodeBashingConfig(data){
        return this.updateTenantConfig("CHECKMARX_CODEBASHING_TRAINING_CONFIG", data);
    },
    
    getSecureCodeWarriorConfig(){
        return this.getTenantConfig("SECURE_CODE_WARRIOR_TRAINING_CONFIG");
    },

    getCodeBashingConfig(){
        return this.getTenantConfig("CHECKMARX_CODEBASHING_TRAINING_CONFIG");
    },
    getAssessmentConfig(){
        return this.getTenantConfig("ASSESSMENT")
    },
    updateAssessmentConfig(data){
        return this.updateTenantConfig("ASSESSMENT", data)
    },
    getDisabledFindingStatus(){
        return this.getTenantConfig("DISABLED_FINDING_STATUS")
    },
    updateDisabledFindingStatus(data){
        return this.updateTenantConfig("DISABLED_FINDING_STATUS", data)
    },
    getDisabledEnvironment(){
        return this.getTenantConfig("DISABLED_ENVIRONMENT");
    },
    updateDisabledEnvironment(data){
        return this.updateTenantConfig("DISABLED_ENVIRONMENT", data);
    },
    getExceptionDefaultConfig(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config/defaultValues?configType=EXCEPTION"
        )
    },
    getExceptionRiskAssessmentFields(){
        return this.getTenantConfig("EXCEPTION_RISK_ASSESSMENT_FIELDS");
    },
    updateExceptionRiskAssessmentFields(data){
        return this.updateTenantConfig("EXCEPTION_RISK_ASSESSMENT_FIELDS", data);
    },
    getRiskRatingsRangeConfig(){
        return this.getTenantConfig("RISK_SCORE_RATINGS_CONFIG");
    },
    getCustomRiskScoreDocLinkConfig(){
        return this.getTenantConfig("CUSTOM_RISK_SCORE_DOCUMENTATION_LINK");
    },
    updateRiskRatingsRangeConfig(data){
        return this.updateTenantConfig("RISK_SCORE_RATINGS_CONFIG", data);
    },
    getHierarchyExcludeSeverityConfig(){
        return this.getTenantConfig("HIERARCHY_SEVERITY_MAPPING");
    },
    updateHierarchyExcludeSeverityConfig(data){
        return this.updateTenantConfig("HIERARCHY_SEVERITY_MAPPING", data);
    },
    getCveRiskCalculationTypeConfig(){
        return this.getTenantConfig("FINDING_SCORE_CALCULATION_TYPE");
    },
    updateCveRiskCalculationTypeConfig(data){
        return this.updateTenantConfig("FINDING_SCORE_CALCULATION_TYPE", data);
    },
    getOnboardingConfig(){
        return this.getTenantConfig("ONBOARDING_CONFIG");
    },
    updateOnboardingConfig(data){
        return this.updateTenantConfig("ONBOARDING_CONFIG", data);
    },
    getFindingCustomFields(){
        return this.getTenantConfig("FINDING_CUSTOM_FIELDS");
    },
    updateFindingCustomtFields(data){
        return this.updateTenantConfig("FINDING_CUSTOM_FIELDS", data);
    },
    getTagGroupSubgroup() {
        return this.getTenantConfig("PRODUCT_SUBPRODUCT_TAG_IDENTIFIERS");
    },  
    updateTagGroupSubgroup(data) {
        return this.updateTenantConfig("PRODUCT_SUBPRODUCT_TAG_IDENTIFIERS", data);
    },
    getAssetDeletionConfig(){
        return this.getTenantConfig("ASSET_DELETION_CONFIG");
    },
    updateAssetDeletionConfig(data){
        return this.updateTenantConfig("ASSET_DELETION_CONFIG", data);
    },
    getBreakDownBySeverity(){
        return this.getTenantConfig("FINDING_SEVERITY_CONFIG");
    },
    updateBreakDownBySeverity(data){
        return this.updateTenantConfig("FINDING_SEVERITY_CONFIG", data);
    },
    getDerivedAttributes(){
        return this.getTenantConfig("FINDING_DERIVED_ATTRIBUTES");
    },
    updateDerivedAttributes(data){
        return this.updateTenantConfig("FINDING_DERIVED_ATTRIBUTES", data);
    },
    getMaterialCodeChanges() {
        return this.getTenantConfig("MATERIAL_CODE_CHANGES");
    },
    updateMaterialCodeChanges(data) {
        return this.updateTenantConfig("MATERIAL_CODE_CHANGES", data);
    },
    getRedLockTagsBasedMatchingBoolean() {
        return this.getTenantConfig("REDLOCK_RESOURCE_TAGS_BASED_MATCHING");
    },
    getCodeInsightsSettings() {
        return this.getTenantConfig("CODE_INSIGHTS");
    },
    getCodeInsightsBeConfig() {
        return this.getTenantConfig("CODE_INSIGHTS_BE_CONFIG");
    },
    updateCodeInsightsSettings(data) {
        return this.updateTenantConfig("CODE_INSIGHTS", data);
    },
    getTOTPConfig() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=TOTP_CONFIGURATION"
        )
    },
    getPingIdentityJITSupport() {
        return this.getTenantConfig("PING_INDENTITY_JIT_ROLE_SUPPORT");
    },
    getSecretMaskingInFindings() {
        return this.getTenantConfig("MASK_FINDING_DESCRIPTION_SECRETS");
    },
    updateSecretMaskingInFindings(enabled) {
        return this.updateTenantConfig("MASK_FINDING_DESCRIPTION_SECRETS", enabled);
    },
    getAccountDefaults() {
        return this.getTenantConfig("ACCOUNT_DEFAULTS");
    },
    updateAccountDefaults(data) {
        return this.updateTenantConfig("ACCOUNT_DEFAULTS", data);
    },
    getProposeCustomFields() {
        return this.getTenantConfig("PROPOSE_MANDATORY_CUSTOM_FIELDS");
    },
    updateProposeCustomFields(data) {
        return this.updateTenantConfig("PROPOSE_MANDATORY_CUSTOM_FIELDS", data);
    },
    getTierBasedTagsV2() {
        return this.getTenantConfig("RISK_TIERS");
    },
    updateTierBasedTagsV2(data) {
        return this.updateTenantConfig("RISK_TIERS", data);
    },
    getRapid7InsightCSPacks() {
        return this.getTenantConfig("RAPID7_INSIGHT_CLOUD_SECURITY_PACK_IDS");
    },
    updateRapid7InsightCSPacks(data) {
        return this.updateTenantConfig("RAPID7_INSIGHT_CLOUD_SECURITY_PACK_IDS", data);
    },
    getRestrictedRoles() {
        return this.getTenantConfig("RESTRICTED_ROLE_MANAGEMENT");
    },
    updateRestrictedRoles(data) {
        return this.updateTenantConfig("RESTRICTED_ROLE_MANAGEMENT", data);
    },
    getExcludeAggregationCardinality(){
        return this.getTenantConfig("EXCLUDE_AGGREGATION_CARDINALITY");
    },
    getAssetCorrelationRuleEngineV2(){
        return this.getTenantConfig("ASSET_CORRELATION_RULE_ENGINE_V2");
    },
    getDefaultFindingColumnConfig(){
        return this.getTenantConfig("DEFAULT_FINDING_COLUMN_CONFIG");
    },
    updateDefaultFindingColumnConfig(data){
        return this.updateTenantConfig("DEFAULT_FINDING_COLUMN_CONFIG", data);
    },
    getRunbookHTTPRequestCap() {
        return this.getTenantConfig("RUNBOOK_HTTP_REQUEST_FINDINGS_CAP");
    },
    getRunbookUIModals() {
        return this.getTenantConfig("RUNBOOK_UI_MODALS");
    },

    getGlobalSettingSlaStatus(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/business-unit-setting"
        )
    },

    updateGlobalSettingEnableSla(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/business-unit-setting",
            { data }
        )
    },

    slaSyncExistingFindings() {
        return makeCancellableAPIRequest(
            "PUT",
            "/api/sla/template/recalculate/all",
        );
    },

    getSLAV3Templates() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/sla/template",
        );
    },

    createSLATemplate(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/sla/template",
            { data }
        );
    },

    updateSLATemplate(id, data) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/sla/template/${id}`,
            { data }
        );
    },

    updateSLATemplateWithRecalculation(id, data) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/sla/template/${id}/recalculate`,
            { data }
        );
    },

    deleteSLATemplate(id, showDefaultMessage = true) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/sla/template/${id}`,
            {},
            showDefaultMessage
        );
    },
}
export default GlobalSettingAPI;
